import React from "react";
import { Helmet } from "react-helmet";
import { useNavigate } from "react-router-dom";
import { Button } from "antd";
import { HomeOutlined } from "@ant-design/icons";
import logo from "assets/icons/RWS_logo-black.svg";
import "./not-found-page.scss";
import { ROUTES } from "../../common/constants/routes";
import { useMercuryContext } from "context/index";

const NotFoundPage: React.FC = () => {
  const navigate = useNavigate();
  const { selectedApp, userDetails } = useMercuryContext();

  const getDefaultPath = (selectedCA: string) => {
    const app = userDetails.customerApplicationDetails?.find((a: any) => a._id === selectedCA);

    switch (app?.name) {
      case "Google":
        return ROUTES.GOOGLE_MAIN;
      case "OLiVE":
        return ROUTES.OLIVE_MAIN;
      default:
        return ROUTES.MAIN;
    }

  }

  const returnHome = (): void => {
    navigate(getDefaultPath(selectedApp));
  };

  return (
    <div className="not-found-page">
      <Helmet>
        <title>Page not found (404) - Mercury © RWS</title>
      </Helmet>

      <div className="container">
        <div className="logo">
          <img src={logo} alt="logo" />
          <h1>| &nbsp;Mercury</h1>
        </div>
        <div className="intro">
          <h1>404 - Page not found</h1>
          <h3>
            The page you are looking for might have been removed or is
            temporarily unavailable.
          </h3>
        </div>
        <Button
          type="link"
          className="login-btn"
          icon={<HomeOutlined />}
          onClick={returnHome}
        >
          Return home
        </Button>
      </div>
    </div>
  );
};

export default NotFoundPage;
